module.exports = __webpack_public_path__ + "img/arrow-up-a-z.ce4b0adc.svg";